import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { StringResolver } from '@pct-ts/typing';
import { resolveString } from '@pct-ts/common';

/**
 * Angular pipe that resolves a string value based on a provided resolver function and parameter.
 *
 * Example:
 * ```typescript
 * // In component
 * data = { name: 'John' };
 * resolver = (item: { name: string }) => item.name;
 * ```
 * ```html
 * // In template using Angular's control flow
 * @if ((data | resolveString:resolver) === 'John') {
 *   <div>Welcome back, John!</div>
 * } @else {
 *   <div>Hello, stranger!</div>
 * }
 * ```
 */

@Pipe({
  name: 'resolveString',
})
export class ResolveStringPipe implements PipeTransform {
  transform<T>(resolver: StringResolver<T>, param: T): string {
    return resolveString(resolver, param);
  }
}
